const gallerySlider = document.querySelector('.js-gallery-slider');

if (gallerySlider) initGallerySlider();

function initGallerySlider() {
  const swiperEl = gallerySlider.querySelector('.js-gallery-swiper');
  const paginationEl = gallerySlider.querySelector('.js-slider-pagination');
  const leftEl = gallerySlider.querySelector('.js-button-slider-left');
  const rightEl = gallerySlider.querySelector('.js-button-slider-right');

  new Swiper(swiperEl, {
        a11y: false,
        speed: 400,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 8,
        freeMode: true,
        mousewheel: true,
        simulateTouch: false,
        watchSlidesProgress: true,
        pagination: {
            el: paginationEl,
            type: "fraction",
            renderFraction: function (currentClass, totalClass) {
                return `<span class="${currentClass}"></span>
                    <span class="">из</span>
                    <span class="${totalClass}"></span>`;
                }
        },
        navigation: {
            nextEl: rightEl,
            prevEl: leftEl,
        },
        breakpoints: {
            1366: {
                slidesPerView: 2,
            },
            350: {
                slidesPerView: "auto",
            }
        }
    });
}
